import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18next from "i18next";

const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();

  const scrollToTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Scroll to top on route/page change (handles refresh & navigation)
  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname, search, hash, key]);

  // Scroll to top on language change (handles SSI injector language switch)
  useEffect(() => {
    i18next.on("languageChanged", scrollToTop);
    return () => {
      i18next.off("languageChanged", scrollToTop);
    };
  }, []);

  return null;
};

export default ScrollToTop;
